import { format } from 'date-fns';
import { nl } from 'date-fns/locale';

export default (date: Date, formatString = 'd LLL yyyy, HH:mm') => (
  format(date, formatString, {
    locale: nl,
  })
);
